module.exports = __webpack_public_path__ + "static/media/drain-accessories.18eac89f.svg";